
// react-bootstrap imports
import { useState } from "react"
import { Button, Form } from "react-bootstrap"

// components imports
import { SenhaInput } from "components/Inputs"
import { ErrorChamadaApiMessage, SuccessDataSaved, WarningIncompleteInput, WarningInvalidInput } from "components/AlertMessages"

import { userLogado } from "services/LoginFunctions"
import { AlterarSenha } from "services/CallAPIs"
import { getFormData } from "services/FormFunctions"

import * as Links from "constants/links"
import { useNavigate } from "react-router-dom"

import stdStyle from "json/StdStyles.json"

export const AlterarMinhaSenhaScreen = () =>
{
    const [showErrorAtualizarSenha, setShowErrorAtualizarSenha] = useState(false)
    const [showSucesso, setShowSucesso] = useState(false)
    const [showAlertIncompleteInput, setShowAlertIncompleteInput] = useState(false)
    const [showAlertDadosIncorretos, setShowAlertDadosIncorretos] = useState(false)
    const [warning, setWarning] = useState("")
    const [error, setError] = useState("")
    const navigate = useNavigate()

    if (!userLogado)
    {
        navigate(Links.SEM_PERMISSAO)
    }

    function validateSenhas()
    {
        let senhasValidas = true
        const senhaInputData = document.getElementsByName("senha")[0].value
        const senhaConfirmarInputData = document.getElementsByName("senhaConfirmar")[0].value
        setWarning("")
        setError("")
        if (senhaInputData !== "" && senhaInputData.length <= 5)
        {
            setWarning("Mínimo de 6 caracteres")
            senhasValidas = false
        }
        if (senhaInputData === "abc123")
        {
            setWarning("Essa senha já está muito manjada! Evite usá-la")
            senhasValidas = false
        }
        if (senhaInputData !== "" && senhaConfirmarInputData !== "" && senhaConfirmarInputData !== senhaInputData)
        {
            setError("Senhas precisam ser iguais")
            senhasValidas = false
        }

        return senhasValidas
    }

    const submitForm = async event =>
    {
        event.preventDefault()
        const form = event.currentTarget
        const formData = getFormData(form)
        const senhasSaoValidas = validateSenhas()
        
        if (!form.checkValidity())
        {
            setShowAlertIncompleteInput(true)
            return
        }
        if (!senhasSaoValidas)
        {
            setShowAlertDadosIncorretos(true)
            return
        }
        if (!form.checkValidity()) { return }
        if (!userLogado) { return }
        if (formData.senha !== formData.senhaConfirmar) { return }

        try
        {
            const data = 
            {
                senhaAtual: formData.senhaAtual,
                senha: formData.senha
            }
            const response = await AlterarSenha(data, setShowErrorAtualizarSenha)

            if (200 <= response.status && response.status <= 299)
            {
                setShowSucesso(true)
            }
            else
            {
                setShowAlertDadosIncorretos(true)
            }
        }
        catch (error)
        {
            setShowAlertDadosIncorretos(true)
        }
    }
    
    return (

        <>
            <SuccessDataSaved show={showSucesso} setShow={setShowSucesso} />
            <WarningInvalidInput show={showAlertDadosIncorretos} setShow={setShowAlertDadosIncorretos} messages={["Senha atual incorreta ou nova senha inválida"]} />
            <WarningIncompleteInput show={showAlertIncompleteInput} setShow={setShowAlertIncompleteInput} />
            <ErrorChamadaApiMessage apiName={"Login"} show={showErrorAtualizarSenha} setShow={setShowErrorAtualizarSenha} />

            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
                
                <SenhaInput Name={"senhaAtual"} Placeholder={"******"} Label={"Senha atual"} Req={true} /> 
                <SenhaInput Name={"senha"} Placeholder={"******"} Label={"Nova senha"} Warn={warning} OnBlur={validateSenhas} Req={true} /> 
                <SenhaInput Name={"senhaConfirmar"} Placeholder={"******"} Label={"Confirme a nova senha"} Errors={error} OnBlur={validateSenhas} Req={true} /> 
                <Button className="mt-3" type="submit">Atualizar senha</Button>

            </Form>
        </>

    )
}